function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 56,
    viewBox: "0 0 49 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57499",
    d: "M99.5 0A3.51 3.51 0 0 0 96 3.5v49a3.51 3.51 0 0 0 3.5 3.5h35a3.51 3.51 0 0 0 3.5-3.5V14L124 0z",
    transform: "translate(-89)",
    style: {
      fill: "#e2e5e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57500",
    d: "M355.5 14H366L352 0v10.5a3.51 3.51 0 0 0 3.5 3.5z",
    transform: "translate(-317)",
    style: {
      fill: "#b0b7bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57501",
    d: "M394.5 138.5 384 128h10.5z",
    transform: "translate(-345.5 -114)",
    style: {
      fill: "#cad1d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57502",
    d: "M74 259.25a1.755 1.755 0 0 1-1.75 1.75h-38.5a1.755 1.755 0 0 1-1.75-1.75v-17.5a1.755 1.755 0 0 1 1.75-1.75h38.5a1.755 1.755 0 0 1 1.75 1.75z",
    transform: "translate(-32 -213.75)",
    style: {
      fill: "#84bd5a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17216"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57503",
    d: "m109.5 298.45 2.434-3.05c.728-.952 2.142.264 1.344 1.174a82.198 82.198 0 0 0-2.56 3.176l2.854 3.554a.919.919 0 1 1-1.524 1.02l-2.576-3.3-2.532 3.374c-.714 1.02-2.3-.126-1.5-1.078l2.812-3.568c-.882-1.106-1.736-2.182-2.588-3.176a.905.905 0 1 1 1.4-1.145z",
    transform: "translate(-97.217 -262.772)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57504",
    d: "M197.36 296.2a.873.873 0 0 1 .882-.854.853.853 0 0 1 .826.854v7.01h3.806a.923.923 0 1 1 0 1.832h-4.631a.845.845 0 0 1-.882-.852v-7.99z",
    transform: "translate(-179.274 -263.04)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57505",
    d: "M270.709 293.952c.322-2.716 4.421-3.2 6.353-1.72a.819.819 0 1 1-.9 1.37c-1.036-.656-3.386-.964-3.68.488-.378 2.3 5.708.982 5.611 4.7-.1 3.554-5.247 3.637-7.179 2.042a1.034 1.034 0 0 1-.2-1.372.826.826 0 0 1 1.246-.1c1.146.782 4.1 1.37 4.308-.618-.168-2.06-5.993-.816-5.559-4.79z",
    transform: "translate(-244.456 -259.534)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 57506",
    d: "M129.25 417.75H96v1.75h33.25a1.755 1.755 0 0 0 1.75-1.75V416a1.755 1.755 0 0 1-1.75 1.75z",
    transform: "translate(-89 -370.5)",
    style: {
      fill: "#cad1d8"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.4505431fa60c81e20f58bc009c232904.svg";
export { ForwardRef as ReactComponent };